export {Skeleton} from 'antd';
export type {SkeletonProps} from 'antd/es/skeleton/index';
